import { render } from "./App.vue?vue&type=template&id=d3e86bb0"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=d3e86bb0&lang=css"
script.render = render

export default script